module.exports = __webpack_public_path__ + "/images/cover-devices.aa1fbb7.jpg";